import styled from 'styled-components'

import { fontWeight } from 'src/styles'
import { media } from 'src/styles/media'

export const PercentWrap = styled.span`
  font-size: initial;
  color: initial;
  font-weight: ${fontWeight.EXTRA};
  margin-right: 4rem;

  ${media.desktop} {
    margin-right: 3rem;
  }
`
